import React, { forwardRef, useRef } from 'react'

import clsx from 'clsx'

import TouchRipple from '../TouchRipple'

import classes from './BaseButton.module.scss'

/** @type {import("./types").default} */
const BaseButton = forwardRef(
  ({ children, className, href, component, onClick, disableRipple = false, ...props }, ref) => {
    const Component = component || (href ? 'a' : 'button')
    const rippleRef = useRef()

    const handleOnClick = e => {
      !disableRipple && rippleRef?.current?.pulsate(e)
      onClick && onClick(e)
    }

    return (
      <Component
        className={clsx('BaseButton', classes.root, className)}
        href={href}
        onClick={handleOnClick}
        ref={ref}
        {...props}
      >
        {children}
        {!disableRipple && <TouchRipple rippleRef={rippleRef} />}
      </Component>
    )
  }
)

export default BaseButton
